<app-panda-party title="{{title}}" src="{{source}}"></app-panda-party>